<div class="field">
  <label class="upper">{{ displayName }}</label>
  @if (showFieldAsEdit) {
    <div>
      <div>
        <topo-switch
          [id]="'bool-field'"
          (click)="isActiveClick()"
          [checked]="value"
        ></topo-switch>
        <label for="bool-field"></label>
      </div>
    </div>
  } @else {
    <div style="position: relative">
      <div style="position: absolute; width: 100%; height: 100%; background-color: transparent; z-index: 99"></div>
      <topo-switch
        [id]="'bool-field'"
        (click)="isActiveClick()"
        [checked]="value"
        readonly
      ></topo-switch>
      <label for="bool-field"></label>
    </div>
  }
</div>
